import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import login from '@/components/login'
import deviceList from '@/components/deviceList'
import deviceEdit from '@/components/deviceEdit'
import deviceInfo from '@/components/deviceInfo'
import map from '@/components/map'
import personal from '@/components/personal'
import Help from '@/components/help'
import About from '@/components/about'
import mangersystem from '@/components/mangersystem'
import Wallet from '@/components/wallet'
import Order from '@/components/order'
import Payment from '@/components/payment'
import PaymentFree from '@/components/paymentfree'
import scan from '@/components/scan'
import recharge from '@/components/recharge'
import serviceAgreement from '@/components/service-agreement'
import feedback from '@/components/feedback'
import binding from '@/components/binding'
import setting from '@/components/setting'


Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      data: { title: '主页' }
    },
    {
      path: '/deviceList',
      name: 'deviceList',
      component: deviceList,
      data: { title: '设备列表' }
    },
    {
      path: '/deviceEdit',
      name: 'deviceEdit',
      component: deviceEdit,
      data: { title: '编辑设备' }
    },
    {
      path: '/deviceInfo/:data',
      name: 'deviceInfo',
      component: deviceInfo,
      data: { title: '设备信息' }
    },
    {
      path: '/map/:data',
      name: 'map',
      component: map,
      data: { title: '设备定位' }
    },
    {
      path: '/personal',
      name: 'personal',
      component: personal,
      data: { title: '个人中心' }
      // children:[
      //   {
      //       path:'/',
      //       component:Help,
      //   },
      //   {
      //       path:'/personal/help',
      //       component:Help,
      //   },
      // ]
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
      data: { title: '使用帮助' }
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: Wallet,
      data: { title: '钱包' }
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      data: { title: '订单' }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      data: { title: '关于我们' }
    },
    {
      path: '/mangersystem',
      name: 'mangersystem',
      component: mangersystem,
      data: { title: '关于我们' }
    },
    {
      path: '/payment/:data',
      name: 'payment',
      component: Payment,
      data: { title: '支付页面' }
    },
    {
      path: '/paymentfree',
      name: 'paymentfree',
      component: PaymentFree,
      data: { title: '免押页面' }
    },
    {
      path: '/scan',
      name: 'scan',
      component: scan
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge
    },
    {
      path: '/service-agreement',
      name: 'service-agreement',
      component: serviceAgreement
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/binding',
      name: 'binding',
      component: binding
    },
    {
      path: '/setting/:data',
      name: 'setting',
      component: setting
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: login
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js